exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Colors */\n/* Borders */\n/* Media */\n/* \n    420px because it will not allow 3 buttons\n    at 30% with 10px margins to be displayed \n    on a single line.\n*/\n/* Common sizes */\n/* z indices */\n.cs-AlterEgo {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n}\n.cs-AlterEgo:hover {\n  background-color: #ffd;\n}\n.cs-AlterEgo__button-box {\n  flex: 1;\n  padding: 10px;\n}\n.cs-AlterEgo__display-name {\n  flex: 10;\n}\n.cs-AlterEgo__role {\n  flex: 3;\n  font-weight: bold;\n}\n.cs-AlterEgo__district {\n  color: #600;\n}\n.cs-AlterEgo__division {\n  color: #060;\n}\n.cs-AlterEgo__super-user {\n  color: #048;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/AlterEgo/AlterEgo.less
// module id = 981
// module chunks = 0